<template>
  <div>
    <b-modal size="xl" id="modal_room" hide-footer v-model="modal_room_control_detail" class="w-100" title="DETALLE DE ESTADIA">
      <b-row>
        <b-col md="3">
          <CCard>
            <CCardHeader>
              <strong>Información de la habitación</strong>
            </CCardHeader>
            <CCardBody>
              <b-list-group>
                <b-list-group-item>
                  <strong>Tipo Habitación :</strong>
                  <span class="pl-2">{{room.type_room_name}}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <strong>Nro Habitación :</strong>
                  <span class="pl-2">{{room.room_number}}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <strong>Precio :</strong>
                  <span class="pl-2">{{room.price}}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <strong>Descripción :</strong>
                  <span class="pl-2">{{room.description}}</span>
                </b-list-group-item>
        
              
              </b-list-group>
            </CCardBody>
          </CCard>
        </b-col>

        <b-col md="5">
          <CCard>
            <CCardHeader>
              <strong>Información de la Estadia</strong>
            </CCardHeader>
            <CCardBody>
              <b-list-group>
                <b-list-group-item>
                  <strong>Cliente :</strong>
                  <span class="pl-2">{{room_control.client_name +' - '+ room_control.client_document_number}}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <strong>Estadia :</strong>
                  <span class="pl-2">{{room_control.start_date + ' - '+ room_control.final_date}}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <strong>Precio x Hora:</strong>
                  <span class="pl-2">{{room_control.price}}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <strong>Total Habitación :</strong>
                  <span class="pl-2">{{room_control.room_price}}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <strong>Total Frigobar :</strong>
                  <span class="pl-2">{{room_control.minibar_price}}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <strong>Total Consumo :</strong>
                  <span class="pl-2">{{room_control.consumer_price}}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <strong>Observación :</strong>
                  <span class="pl-2">{{room_control.observation}}</span>
                </b-list-group-item>
                <b-list-group-item>
                  <strong>Estado :</strong>
                  <span v-if="room_control.state == 1" class="pl-2">Ocupado</span>
                  <span v-if="room_control.state == 2" class="pl-2">En Espera de Mantenimiento</span>
                  <span v-if="room_control.state == 3" class="pl-2">En Mantenimiento</span>
                </b-list-group-item>
        
              </b-list-group>
            </CCardBody>
          </CCard>
        </b-col>


        <b-col md="4">
          <CCard>
            <CCardHeader>
              <strong>Información de Frigobar</strong>
            </CCardHeader>
            <CCardBody>
              
                  <b-row>
                      <b-col md="12">
                          <div class="table-responsive mt-3">
                            <table class="table table-striped table-hover table-bordered table-lg mt-lg mb-0">
                              <thead>
                                <tr>
                                  <th class="text-center">#</th>
                                  <th class="text-center">Codigo</th>
                                  <th class="text-center">Nombre</th>
                                  <th class="text-center">Cantidad</th>
                                  <th class="text-center">P. Unit</th>
                                  <th class="text-center">P. Total</th>
                                </tr>
                              </thead>
                              <tbody v-for="(item, it) in room_control_minibar" :key="it">
                                <tr>
                                  <td class="text-center">{{ it + 1 }}</td>
                                  <td class="text-left">{{ item.code }}</td>
                                  <td class="text-left">{{ item.name }}</td>
                                  <td class="text-center">{{ item.quantity }}</td>
                                  <td class="text-right">{{ item.unit_price }}</td>
                                  <td class="text-right">{{ item.total_price }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                      </b-col>
                </b-row>
            </CCardBody>
          </CCard>




          <CCard>
            <CCardHeader>
              <strong>Información de Consumo</strong>
            </CCardHeader>
            <CCardBody>
              
                <b-row>
            <b-col md="12">
                <div class="table-responsive mt-3">
                  <table class="table table-striped table-hover table-bordered table-lg mt-lg mb-0">
                    <thead>
                      <tr>
                        <th class="text-center">#</th>
                        <th class="text-center">Codigo</th>
                        <th class="text-center">Nombre</th>
                        <th class="text-center">Cantidad</th>
                        <th class="text-center">P. Unit</th>
                        <th class="text-center">P. Total</th>
                        
                      </tr>
                    </thead>
                    <tbody v-for="(item, it) in room_control_consumer" :key="it">
                      <tr>
                        <td class="text-center">{{ it + 1 }}</td>
                        <td class="text-left">{{ item.code }}</td>
                        <td class="text-left">{{ item.name }}</td>
                        <td class="text-center">{{ item.quantity }}</td>
                        <td class="text-right">{{ item.unit_price }}</td>
                        <td class="text-right">{{ item.total_price }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </b-col>
      </b-row>
            </CCardBody>
          </CCard>
          
        </b-col>


 

      </b-row>
    </b-modal>



  


    <!-- Modal Cliente -->
    <!-- <ModalClientRoom/> -->
  </div>
</template>


<style >



</style>
 
<script>
///import vue select
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
var moment = require("moment");
import { mapState,mapMutations,mapActions } from "vuex";
import EventBus from "@/assets/js/EventBus";


// import ModalClientRoom from './../../components/ModalClient'

export default {
  name: "ModalRoomControl",
  components:{
    // ModalClientRoom,
    vSelect
  },
  data() {
    return {

        module: 'RoomControl',
        role:3,

        modal_room_control_detail:false,
        id_room: 0,
        room: {
          id_room:0,
          id_type_room:0,
          room_number:'',
          photo:'',
          price:0,
          description:'',
          type_room_name:'',
        },
        room_control:{
          client_name:'',
          client_document_number:'',
          id_room:0,
          id_type_room:0,
          id_user:0,
          id_client:'',
          date:'',
          hour:'',
          start_date:'',
          final_date:'',
          price:'',
          quantity:'',
          room_price:'',
          observation:'',
        },

        clients:[],
        client:null,

        room_control_minibar: [],
        room_control_consumer:[],

        errors:{
          id_client:false,
          start_date:false,
          final_date:false,
          price:false,
          quantity:false,
          room_price:false,
        },
        validate: false,
    };
  },
  mounted () {
      EventBus.$on('ModalRoomControlDetailShow', (id_room,id_room_control) => {
        this.id_room_control = id_room_control;
        this.id_room = id_room;
        this.ViewRoom();
        this.ViewRoomControl();
        this.ListRoomControlMinibar();
        this.ListRoomControlConsumer();
        this.modal_room_control_detail= true;
      });




  },
  methods: {
      search(search, loading) {
        let me = this;
        let url = this.url_base + "search-clients/" + search;
        if (search !== "") {
          loading(true);
          axios({
            method: "GET",
            url: url,
          }).then(function (response) {
                me.clients = response.data;
                loading(false);
          })
        }
      },
      ViewRoom,
      ViewRoomControl,
      CalculateEndDate,
      EditRoomControl,
      Validate,
      ShowModalClient,
      ListRoomControlMinibar,
      ListRoomControlConsumer,
      ...mapActions('RoomControl',['mLoadListRoomControl']),
  },
  computed: {
    ...mapState(["url_base"]),
    // ...mapState('RoomControl',['room_control_rc']),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    id_user: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.id_user;
    },

  },
};

//Ver habitacion
function ViewRoom() {
 
  let me = this;
  let url = this.url_base + "room/view/" + this.id_room;

  axios({
    method: "GET",
    url: url,
    headers: {
      token: this.token,
      module: this.module,
      role: this.role,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.room.id_room = response.data.result.id_room;
        me.room.id_type_room = response.data.result.id_type_room;
        me.room.room_number = response.data.result.room_number;
        me.room.photo = response.data.result.photo;
        me.room.price = response.data.result.price;
        me.room.description = response.data.result.description;
        me.room.type_room_name = response.data.result.type_room_name;

      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })


}

function ViewRoomControl() {
  let me = this;
  let url = this.url_base + "room-control/view/" + this.id_room_control;

  axios({
    method: "GET",
    url: url,
    headers: {
      token: this.token,
      module: this.module,
      role: this.role,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.client = {id : response.data.result.id_client, full_name: response.data.result.client_name + ' - ' + response.data.result.client_document_number};

        me.room_control.client_name = response.data.result.client_name;
        me.room_control.client_document_number = response.data.result.client_document_number;
        me.room_control.id_client = response.data.result.id_client;
        me.room_control.id_room = response.data.result.id_room;
        me.room_control.id_type_room = response.data.result.id_type_room;
        me.room_control.id_room_control = response.data.result.id_room_control;
        me.room_control.id_user = response.data.result.id_user;
        me.room_control.price = response.data.result.price;
        me.room_control.quantity = response.data.result.quantity;
        me.room_control.start_date = response.data.result.start_date;
        me.room_control.final_date = response.data.result.final_date;
        me.room_control.date = moment(response.data.result.date).local().format("YYYY-MM-DD");
        me.room_control.hour = response.data.result.hour;
        me.room_control.room_price = response.data.result.room_price;
        me.room_control.minibar_price = response.data.result.minibar_price;
        me.room_control.consumer_price = response.data.result.consumer_price;
        me.room_control.observation = response.data.result.observation;
        me.room_control.state = response.data.result.state;
    
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })

}

//Calcular fecha final
function CalculateEndDate() {
  
  
  this.room_control.final_date = moment(this.room_control.start_date, "YYYY-MM-DD HH:mm:ss").add(parseInt(this.room_control.quantity) , 'quantity').local().format("YYYY-MM-DD HH:mm:ss");
  this.room_control.room_price = parseFloat(this.room_control.quantity) * parseFloat(this.room_control.price); 

  this.room_control.price = parseFloat(this.room_control.price).toFixed(2);
  this.room_control.room_price = this.room_control.room_price.toFixed(2);

}
//modal new cliente
function ShowModalClient() {
  
  EventBus.$emit('ModalClient');
}

//agregar control habitacion
function EditRoomControl() {

  this.Validate();
  if (this.validate) {
    return false;
  }

  this.room_control.id_client = this.client.id;
  let me = this;
  let url = this.url_base + "room-control/edit";
  let data = this.room_control;

  

  axios({
    method: "PUT",
    url: url,
    data: data,
    headers: {
      "Content-Type": "application/json",
      token: this.token,
      module: this.module,
      role: this.role,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.mLoadListRoomControl();
        Swal.fire("Sistema", "Se ha actualizado la estadia", "success");
      } else if  (response.data.status == 409) {
        me.mLoadListRoomControl();
        Swal.fire("Sistema", "La habitacion seleccionado ya no se encuentra disponible", "error");
        me.modal_room = false;
      }else{
          Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}


function ListRoomControlMinibar() {

  let me = this;
  let url = this.url_base + "room-control-detail/list/"+this.id_room_control+"/Minibar";

  axios({
    method: "GET",
    url: url,
    headers: {
      token: this.token,
      module: this.module,
      role: this.role,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.room_control_minibar = response.data.result;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
}


function ListRoomControlConsumer() {

  let me = this;
  let url = this.url_base + "room-control-detail/list/"+this.id_room_control+"/Consumer";

  axios({
    method: "GET",
    url: url,
    headers: {
      token: this.token,
      module: this.module,
      role: this.role,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.room_control_consumer = response.data.result;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
}

function Validate() {

  this.validate = false;
  this.errors.id_client = this.client == null || this.client == {} ? true : false;
  this.errors.final_date = this.room_control.start_date.length == 0 ? true : false;
  this.errors.price = this.room_control.start_date.length == 0 ? true : false;
  this.errors.quantity = this.room_control.start_date.length == 0 ? true : false;
  this.errors.room_price = this.room_control.start_date.length == 0 ? true : false;

  if (this.errors.id_client) { this.validate = true; return false;}else{ this.validate = false; }
  if (this.errors.final_date) { this.validate = true; return false;}else{ this.validate = false; }
  if (this.errors.price) { this.validate = true; return false;}else{ this.validate = false; }
  if (this.errors.quantity) { this.validate = true; return false;}else{ this.validate = false; }
  if (this.errors.room_price) { this.validate = true; return false;}else{ this.validate = false; }

}


</script>